import { InputBase, TableCell } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addIndex, removeIndex } from "../../redux/slices/newRowIndexSlice";
import { addInput, removeInput } from "../../redux/slices/newRowSlice";

export default function AddRow({ index, varType, submit, column, rows, setErrMsg }) {
    const [cellInput, setCellInput] = useState("")


    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(addInput(cellInput))
        dispatch(removeIndex(""))
        dispatch(removeInput(""))
        if(cellInput !== "") {
            dispatch(addIndex(index))
        }
    }, [submit])

    return(
        <TableCell
            key={index}
            size="small"
            sx={{
                color: "#fff",
                borderBottom: "none",
                height: "45px",
            }}
        >
            <InputBase
                value={column === "row_id" ? rows.length + 1 : cellInput}
                placeholder={`Add new ${varType}`}
                sx={{
                    backgroundColor: "#040417",
                    color: "#fff",
                    borderRadius: "9px",
                    pl: "10px",
                    minHeight: "45px",
                    border: "1px solid #114BA3",
                    fontFamily: "Averta",
                    width: "100%",
                    margin: "auto"
                }}
                id="outlined-basic"
                variant="filled"
                label=""
                onChange={(e) => {
                    if (column === "row_id") {
                        setErrMsg("Cannot edit row_id!")
                    } else {
                        setCellInput(e.target.value)
                    }
                }}
            />
        </TableCell>
    )
}